import { render, staticRenderFns } from "./TertiaryButton.vue?vue&type=template&id=546784f8&"
var script = {}
import style0 from "./TertiaryButton.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/opt/build/repo/storefront/components/atoms/Button/BaseButton.vue').default})
